<template>
    <FormControl
        label="Allow multi-seat bookings"
        :error="
            errors.getValidationError(
                RequestBodyKeyEnum.App_UpdateService_GroupSchedulingSettings_IsMultiSeatAllowed,
            )
        "
    >
        <ToggleInput
            label="Allow attendees to reserve more than one seat in a single booking"
            :name="
                RequestBodyKeyEnum.App_UpdateService_GroupSchedulingSettings_IsMultiSeatAllowed
            "
            :checked="dummyIsMultiSeatAllowed"
            :disabled="isDisabled"
            v-model="dummyIsMultiSeatAllowed"
        />
    </FormControl>

    <template v-if="!dummyIsMultiSeatAllowed">
        <input
            type="hidden"
            :name="
                RequestBodyKeyEnum.App_UpdateService_GroupSchedulingSettings_MaximumNumberOfSeatsPerAttendee
            "
            value="1"
        />
    </template>
    <template v-else>
        <FormControl
            label="Maximum seats per attendee"
            :error="
                errors.getValidationError(
                    RequestBodyKeyEnum.App_UpdateService_GroupSchedulingSettings_MaximumNumberOfSeatsPerAttendee,
                )
            "
        >
            <TextInput
                type="number"
                inputmode="numeric"
                step="1"
                min="2"
                :max="service.maximumNumberOfSeatsPerMeeting"
                :name="
                    RequestBodyKeyEnum.App_UpdateService_GroupSchedulingSettings_MaximumNumberOfSeatsPerAttendee
                "
                v-model="dummyMaximumNumberOfSeatsPerAttendee"
                :disabled="isDisabled"
            />
        </FormControl>
    </template>
</template>

<script setup lang="ts">
    import { ref, watch, type PropType } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ToggleInput from '@/Shared/Component/Forms/ToggleInput.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
    })

    const dummyIsMultiSeatAllowed = ref<boolean>(
        props.service.groupSchedulingSettings.isMultiSeatAllowed,
    )
    const dummyMaximumNumberOfSeatsPerAttendee = ref<string>(
        props.service.groupSchedulingSettings.maximumNumberOfSeatsPerAttendee.toString(),
    )

    watch(dummyIsMultiSeatAllowed, () => {
        if (
            dummyIsMultiSeatAllowed.value &&
            Number(dummyMaximumNumberOfSeatsPerAttendee.value) < 2
        ) {
            dummyMaximumNumberOfSeatsPerAttendee.value = '2'
        }
    })
</script>
